import styled from 'styled-components';
import getColour from '@lendi-ui/commons/colours';

interface BarProps {
  progress?: number;
}

export const Meter = styled.div`
  background-color: ${() => getColour('fill', 'selected')};
  height: 12px;
  position: fixed;
  width: 100%;
  z-index: 1;
`;

export const Bar = styled.div<BarProps>`
  height: 100%;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  width: ${({ progress }) => progress}%;
  background-color: ${() => getColour('fill', 'accent')};
`;
